<script>
  // TODO: make filter look like design
  // TODO: implement recommended terms
  // TODO: check if we can prioritize products in the search results
  import algoliasearch from 'algoliasearch/lite'
  import { history } from 'instantsearch.js/es/lib/routers'
  import ProductCardSearch from '@/components/Ecommerce/Products/ProductCardSearch'

  const algoliaClient = algoliasearch(
    process.env.ALGOLIA_ID, // Application ID
    process.env.ALGOLIA_SEARCH_KEY // Search-Only API Key
  )

  const indexName = process.env.ALGOLIA_INDEX

  export default {
    components: {
      ProductCardSearch
    },
    data () {
      return {
        routing: {
          router: history(),
          stateMapping: {
            stateToRoute (uiState) {
              return { query: uiState[indexName].query }
            },
            routeToState (routeState) {
              return { [indexName]: { query: routeState.query } }
            }
          }
        },
        algoliaClient: {
          search (requests) {
            if (requests.every(({ params }) => !params.query)) {
              return Promise.resolve({
                results: requests.map(() => ({
                  hits: [],
                  nbHits: 0,
                  nbPages: 0,
                  processingTimeMS: 0
                }))
              })
            }
            return algoliaClient.search(requests)
          }
        },
        indexName
      }
    },
    methods: {
      pageChange () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      getClosestMatch (item) {
        let matched = ''
        if (Object.keys(item._highlightResult).length !== 0) {
          for (const key of Object.keys(item._highlightResult)) {
            const value = item._highlightResult[key]
            if (
              (value.matchLevel === 'full' || value.matchLevel === 'partial') &&
              ((key.startsWith('title') && key !== 'title') ||
                (key.startsWith('content') && key !== 'contentType') ||
                key.startsWith('introduction'))
            ) {
              matched = key
              if (value.matchLevel === 'full') {
                break
              }
            }
          }
        }
        return matched
      }
    }
  }
</script>

<template>
  <div class="view view-search">
    <div class="view-header pb-10 md:pb-20">
      <div class="w-full md:w-10/12 xl:w-6/12 mx-auto mb-6">
        <div class="container px-4 md:px-8">
          <div class="w-full md:w-10/12 xl:w-6/12 mx-auto md:text-center">
            <animated-title>
              <h1 class="animate text-3xl md:text-5xl pb-0 md:pb-4 text-center">
                Zoeken
              </h1>
            </animated-title>
          </div>
        </div>
      </div>
      <client-only>
        <ais-instant-search
          class="container mx-auto"
          :routing="routing"
          :search-client="algoliaClient"
          :index-name="indexName"
        >
          <div class="w-full md:w-9/12 lg:w-7/12 xl:w-8-12 mx-auto mb-6">
            <div class="px-4 md:px-8">
              <div class="w-full">
                <ais-search-box
                  autofocus
                  placeholder="Waar ben je naar op zoek?"
                />
                <ais-refinement-list
                  attribute="contentType"
                  :sort-by="['name:asc']"
                />
              </div>
            </div>
          </div>

          <div class="w-full md:w-10/12 mx-auto mb-6">
            <div class="px-4 md:px-8">
              <div class="w-full">
                <ais-hits>
                  <template #item="{ item }">
                    <article
                      v-if="item.contentType !== 'Product'"
                      class="w-full relative overflow-hidden"
                    >
                      <nuxt-link
                        :to="item.url"
                        class="
                          py-8
                          flex
                          content-center
                          items-center
                          transition-opacity
                          hover:opacity-50
                        "
                      >
                        <img
                          v-if="item.image"
                          :src="item.image + '?w=96&h=96&fit=thumb'"
                          :alt="item.title"
                          class="mr-6 rounded-sm"
                        >
                        <div class="flex flex-col">
                          <div class="text-xs text-gray-600">
                            {{ item.contentType }}
                            <span
                              v-if="
                                item.createdAt && item.contentType !== 'Pagina'
                              "
                              class="text-gray-400"
                            >
                              -
                              {{
                                $dateFns.format(
                                  $dateFns.fromUnixTime(item.createdAt),
                                  "dd MMM yyyy"
                                )
                              }}</span>
                          </div>
                          <h2
                            class="
                              font-primary
                              text-lg
                              leading-normal
                              truncateTitle
                            "
                          >
                            <ais-highlight
                              attribute="title"
                              :hit="item"
                            />
                          </h2>
                          <!-- show content with highlight -->
                          <div
                            v-if="getClosestMatch(item) !== ''"
                            class="truncateDesc"
                          >
                            <ais-snippet
                              :attribute="getClosestMatch(item)"
                              :hit="item"
                            />
                          </div>
                        </div>
                      </nuxt-link>
                    </article>
                    <ProductCardSearch
                      v-else
                      :product="item"
                    />
                  </template>
                </ais-hits>
                <ais-state-results>
                  <template
                    slot-scope="{
                      state: { query },
                      results: { hits, nbPages },
                    }"
                  >
                    <!-- show no result if query with no hits -->
                    <div
                      v-if="query && hits.length == 0"
                      class="text-center"
                    >
                      Geen resultaten
                    </div>

                    <ais-pagination
                      v-if="nbPages > 1"
                      :padding="$device.isMobile ? 1 : 2"
                      :show-last="false"
                      :show-first="false"
                      @page-change="pageChange"
                    />
                    <!-- hide pagination if 1 or less pages -->

                    <div
                      v-if="hits.length > 0"
                      class="
                        flex flex-col
                        md:flex-row
                        items-center
                        md:justify-between
                        mt-10 mt:pb-20
                      "
                    >
                      <div
                        class="flex flex-col items-start space-y-8 md:max-w-2xl"
                      >
                        <h2 class="text-2xl">
                          Vind nog meer examenmateriaal op Mijn Examenbundel
                        </h2>
                        <p>
                          Met Mijn Examenbundel kun je oefenen met gratis
                          oefenexamens, antwoorden van oriëntatietoetsen en
                          meer!
                        </p>
                        <e-button
                          tag="nuxt-link"
                          to="/mijnexamenbundel"
                          aria-label="Meld je gratis aan!"
                          type="primary"
                        >
                          <q-icon name="profile" />
                          <span class="ml-2 xl:block">
                            Meld je gratis aan!
                          </span>
                        </e-button>
                      </div>
                      <img
                        src="@/assets/img/searchCta.png"
                        alt=""
                        class="ml-0 md:ml-20 mt-8 md:mt-0 w-full md:w-auto"
                      >
                    </div>
                  </template>
                </ais-state-results>
              </div>
            </div>
          </div>
          <!-- <ais-powered-by class="px-8 mt-6 md:mt-0 justify-around" /> -->
        </ais-instant-search>
      </client-only>
    </div>
  </div>
</template>

<style lang="scss">
@import "instantsearch.css/themes/algolia-min.css";
.view-search {
  @apply pb-0;
}
/* add bottom margin to search box */
.ais-SearchBox {
  margin-bottom: 1em;
  input {
    box-shadow: 0 0.625rem 1.25rem rgba(0, 0, 0, 0.04), 0 0.125rem 0.375rem rgba(0, 0, 0, 0.04), 0 0 0.0625 rgba(0, 0, 0, 0.04);
    border-radius: 0.625rem;
    @apply pl-9 pr-2 py-2 leading-8 focus:outline-none;
  }
  button[type="submit"] {
    @apply left-3;
  }
  button[type="reset"] {
    @apply right-3;
  }
}

.ais-Hits-list {
  @apply flex m-0 p-0;
}

.ais-Hits-item {
  @apply border-0 p-0 flex w-full m-0 shadow-none;
  & + & {
    @apply border-t border-gray-200;
  }
}

.ais-Highlight {
  font-size: inherit;
}

.ais-Highlight-highlighted {
  font-size: inherit;
}

.truncateTitle {
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

.truncateDesc {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

.ais-RefinementList-list {
  @apply grid grid-cols-2 md:grid-cols-3 gap-x-4 md:gap-x-8;
}

.ais-Pagination-link {
  @apply font-primary;
  @apply inline-flex items-center justify-center;
  @apply text-base font-bold text-black bg-transparent;
  @apply px-4 py-3;
  @apply border-0;
  @apply no-underline;
  @apply cursor-pointer;
  @apply rounded;
  @apply w-12;

  line-height: 1.5;
  transition: background-color 0.3s ease(easeOutSine),
  box-shadow 0.3s ease(easeOutSine);
  box-shadow: inset 0 0 0 0.125rem theme("colors.gray.200");

  &:focus {
    @apply outline-none;
  }
  &:disabled,
  &.is-disabled {
    @apply text-gray-200 cursor-not-allowed #{!important};
  }
  &:hover:not(:disabled),
  .ais-Pagination-item--selected & {
    box-shadow: inset 0 0 0 0.125rem theme("colors.black");
    @apply bg-white text-black;

    &:focus {
      @apply text-black;
    }
  }
}

.ais-Pagination-list {
  @apply flex justify-between space-x-2;
}

@media (min-width: 321px) {
  .ais-Pagination-list {
    @apply sm:justify-center;
  }
}
</style>
